<template>
  <div>
    <div class="bg-gray">
      <banner-bg
          title="组织结构"
          subtitle="相信团队的力量"
          :src="require('@/assets/images/mainindex/organization-banner@2x.png')"
      ></banner-bg>

      <!-- <special-tabs class="special-box" :activeName="activeName" :tabList="tabList" @onClick="onClick"></special-tabs> -->

      <!-- 全国 是一篇文章哦-->
      <div class="container-content container-wrap" v-if="activeName === '全国'" v-html="articleRow.data.content">
        <!--        <p>-->
        <!--          联系地址：江苏省南京市秦淮区永智路6号四号楼A栋3楼302-307-->
        <!--        </p>-->
        <!--        <p>-->
        <!--          联系电话：025-85310501或025-52310509-->
        <!--        </p>-->
        <!--        <iframe width="504" height="425" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="http://j.map.baidu.com/fi-oO">-->
        <!--        </iframe>-->
      </div>

      <!-- 各省市-->
      <div class="organization_content" v-else>
        <div class="header_screen container-wrap">
          <div class="header_screen_item">
            <div class="header_screen_item_title">省份：</div>
            <div class="header_screen_item_content">
              <!-- <div
                  class="header_screen_item_el" :class="params.weiyuanhui_id == 0 ? 'header_screen_item_el_active' : 0"
                  @click="onSelectArea(0)">全部
              </div> -->
              <div
                  class="header_screen_item_el"
                  v-for="(item, index) in areaList"
                  v-show="index>0"
                  :key="index"
                  :class="params.weiyuanhui_id == item.id ? 'header_screen_item_el_active' : 0"
                  @click="onSelectArea(item.id)"
              >
                {{ item.province }}
              </div>
            </div>
          </div>


          <div class="header_screen_item">
            <div class="header_screen_item_title">类型：</div>
            <div class="header_screen_item_content">

              <div
                  class="header_screen_item_el"
                  v-for="(item, index) in typeData"
                  :key="index"
                  :class="params.area_type == item.key ? 'header_screen_item_el_active' : 0"
                  @click="onSelectType(item.key)"
              >
                {{ item.name }}
              </div>
            </div>
          </div>
          <div class="header_screen_item"></div>
        </div>
        <div class="organization_content_list container-wrap">
          <div class="organization_content_list_item" v-for="(item,index) in list" :key="index">
            <div class="organization_content_list_item_left">
              <!--              <img src="../../assets/images/mainindex/organization-banner@2x.png" alt="">-->
              <!--              <img :src="item.wechat_pic_url" alt="">-->
              <el-image
                  :src="item.wechat_pic_url"
                  :preview-src-list="[item.wechat_pic_url]">
              </el-image>
              <div class="organization_content_list_item_tip">加我企业微信</div>
            </div>
            <div class="organization_content_list_item_desc">
              <div class="organization_content_list_item_desc_tip">全国跳绳推广委员会</div>
              <div class="organization_content_list_item_desc_title">
                {{ item.area_type == 1 ? item.province : item.city }}推广负责人
              </div>
              <div class="organization_content_list_item_desc_contacts">
                姓名&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ item.name }}
              </div>
              <div class="organization_content_list_item_desc_contacts">
                电话&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ item.phone }}
              </div>
            </div>
            <div class="organization_content_list_item_tag_province" v-if="item.area_type == 1">省级</div>
            <div class="organization_content_list_item_tag" v-else>市级</div>
          </div>

          <el-pagination
              v-if="row.totalpage > 1"
              style="padding-bottom: 20px;"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="row.p"
              :page-size="row.step"
              background
              layout="total, prev, pager, next"
              :total="row.total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SpecialTabs from "@/components/mainindex/SpecialTabs";
import BannerBg from "@/components/mainindex/BannerBg";

export default {
  name: "Organization",
  data() {
    return {
      provinceDataArr: [
        {name: "全部", class: "header_screen_item_el_active"},
        {name: "北京", class: ""},
        {name: "江苏", class: ""},
        {name: "黑龙江", class: ""},
        {name: "上海", class: ""},
        {name: "安徽", class: ""},
        {name: "山东", class: ""},
        {name: "山西", class: ""},
        {name: "陕西", class: ""},
        {name: "新疆", class: ""},
        {name: "吉林", class: ""},
        {name: "宁夏", class: ""},
        {name: "内蒙古", class: ""},
        {name: "内蒙古", class: ""},
        {name: "内蒙古", class: ""},
        {name: "辽宁", class: ""},
      ],
      typeData: [
        // {name: "全部", class: "header_screen_item_el_active", key: 0},
        {name: "省级", class: "", key: 1},
        {name: "市级", class: "", key: 2},
      ],

      areaList: [],
      list: [],

      url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
      srcList: [
        'https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg',
        'https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg'
      ],
      params: {
        pageNo: 1,
        pageSize: 9,
        weiyuanhui_id: 0,
        area_type: 1,
      },

      row: {},
      articleRow: {},

      tabList: [
        {name: "全国", class: "tabs-item-active"},
        {name: "各省市", class: ""},
      ],
      activeName: '全国'
    };
  },
  mounted() {
    document.title = "组织结构"
    this.fetch();
    this.getAreaList();
    this.getArticleDetail()
  },
  methods: {
    fetch() {
      let that = this;
      that.$api.get(
          "/api/weiyuanhui/wyhAdminList",
          that.params,
          res => {
            that.loading = false;

            res.data.p = parseInt(res.data.p)
            res.data.step = parseInt(res.data.step)
            res.data.total = parseInt(res.data.total)
            that.row = res.data
            if (res.data.currentpage == 1) {
              that.isLoading = false;
              that.list = res.data.list;
            } else {
              that.list = that.list.concat(res.data.list);
            }
            if (res.data.list.length == 0) {
              that.finished = true;
            }

            that.params.pageNo += 1;
          },
          res => {
            that.$message.error(res.msg);
          }
      );
    },


    getArticleDetail() {
      let that = this,
          id = 347

      that.$api.get(
          "/api/cms/detail",
          {
            id: id,
          },
          (res) => {
            // this.$message.success("发送成功");
            // console.log("resres.....",res)
            that.articleRow = res.data
          },
          (r) => {
            that.$message.error(r.msg);
          }
      );
    },

    getAreaList() {
      let that = this;
      that.$api.get(
          "/api/weiyuanhui/wyhProvinceAreaList",
          {}, res => {
            that.areaList = res.data
          },
          res => {
            that.$message.error(res.msg);
          });
    },

    onSelectArea(id) {


      if(id == '3530'){

        rbLink({
          name: "NewsDetail",
          query: {
            id:595
          }
        });

        return;
      }
      this.params.pageNo = 1;
      this.list = []
      this.params.weiyuanhui_id = id

      this.loading = true;
      this.finished = false;
      this.fetch();
    },

    handleSizeChange(val) {
      this.list = []
      this.params.pageSize = val;
      this.fetch();
    },
    handleCurrentChange(val) {
      this.list = []
      this.params.pageNo = val;
      this.fetch();
    },

    onClick(record) {
      // console.log('onClick', record)
      this.activeName = record.name
    },

    onPreview(row) {
      // ImagePreview([pic])

      console.log('onPreview', row)
      this.filename = row.name + '的企业微信'
      this.certUrl = row.wechat_pic_url

      this.showCert = true
    },

    onSelectType(id) {
      this.params.pageNo = 1;
      this.list = []
      this.params.area_type = id

      this.loading = true;
      this.finished = false;
      this.fetch();
    },
  },
  components: {
    BannerBg,
    SpecialTabs,
  },
};
</script>
<style scoped>
.container-content>>> img {
  max-width: 100%;
}
</style>
<style lang="scss" scoped>

.special_tabs {
  position: relative;
  top: -59px;
  text-align: center;
}

.container-content {

  p {
    margin-bottom: 15px;
    color: #000;
    font-size: 14px;
    font-weight: 500;
  }
}

.organization_content {
  .header_screen {
    width: 1200px;
    //height: 132px;
    background: #ffffff;
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.05);
    margin-bottom: 30px;
    margin-top: -18px;
    position: relative;
    box-sizing: border-box;
    padding: 30px 0 20px 24px;

    .header_screen_item {
      display: flex;
      flex-direction: row;
      //align-items: center;
      //height: 40px;
      cursor: default;

      .header_screen_item_title {
        height: 20px;
        min-width: 42px;
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        line-height: 20px;
        margin-right: 41px;
      }

      .header_screen_item_el {
        height: 20px;
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        line-height: 20px;
        margin-right: 41px;
        margin-bottom: 10px;
        float: left;

        &:hover {
          cursor: pointer;
          color: #f56057;
        }
      }

      .header_screen_item_el_active {
        color: #f56057;
      }
    }
  }

  .organization_content_list {
    font-size: 0;

    .organization_content_list_item {
      width: 380px;
      height: 140px;
      background: #ffffff;
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.06);
      border-radius: 10px;
      display: inline-flex;
      flex-direction: row;
      padding: 16px 0 0 16px;
      margin-right: 30px;
      margin-bottom: 30px;
      box-sizing: border-box;
      position: relative;
      transition: all 0.4s;

      &:nth-child(3n) {
        margin-right: 0;
      }

      &:hover {
        cursor: pointer;
        transform: scale(1.03);
      }

      .organization_content_list_item_left {
        text-align: center;
        margin-right: 16px;

        .el-image {
          box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
          width: 90px;
          height: 90px;
          border-radius: 3px;
        }

        .organization_content_list_item_tip {
          margin-top: 5px;
          font-size: 14px;
          font-weight: 400;
          color: #999999;
        }
      }

      .organization_content_list_item_desc {
        flex: 1;

        .organization_content_list_item_desc_tip {
          font-size: 14px;
        }

        .organization_content_list_item_desc_title {
          height: 32px;
          font-size: 22px;
          font-weight: 500;
          color: #000000;
          line-height: 32px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          margin-bottom: 7px;

          width: 260px;
        }

        .organization_content_list_item_desc_contacts {
          font-size: 14px;
          font-weight: 400;
          color: #444444;

          line-height: 27px;
        }
      }

      .organization_content_list_item_tag_province {
        width: 61px;
        height: 28px;
        line-height: 28px;
        text-align: center;
        background: linear-gradient(133deg, #FA6400 0%, #FD9D00 100%);
        border-radius: 10px 0px 10px 10px;
        position: absolute;
        bottom: 0;
        right: 0;
        font-size: 14px;
        font-weight: 500;
        color: #ffffff;
      }

      .organization_content_list_item_tag {
        width: 61px;
        height: 28px;
        line-height: 28px;
        text-align: center;
        background: linear-gradient(130deg, #7798FF 0%, #D4E1FF 100%);;
        border-radius: 10px 0px 10px 10px;
        position: absolute;
        bottom: 0;
        right: 0;
        font-size: 14px;
        font-weight: 500;
        color: #ffffff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Organization.vue?192d3da1